import script from "./PageSectionList.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSectionList.vue?vue&type=script&setup=true&lang=js"

import "./PageSectionList.vue?vue&type=style&index=0&id=3b052884&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b052884"]])

export default __exports__